import React, { Component } from "react";
import Paper from "material-ui-next/Paper";
import Typography from "material-ui-next/Typography";
import {
  Page,
  Loadable,
  DataTable,
  /*Fab,*/ StyledButton,
  If
} from "components/support";
import Icons from "material-ui-next/Icon";
import { StockOperation } from "core/enum";
import { Row, Col } from "react-flexbox-grid";
//import { colors, Icon } from 'assets';
import Filter from "./filters/index";

const config = {
  identifier: "uuid",
  columns: [
    {
      accessor: "created_at",
      type: "datetime",
      align: "center",
      Header: "Data"
    },
    {
      accessor: "product_name.name",
      align: "center",
      Header: "Produto",
      sortable: false
    },
    {
      accessor: "activity",
      type: "enum",
      align: "center",
      Header: "Operação",
      params: { enum: StockOperation },
      sortable: false
    },
    {
      accessor: "amount",
      align: "center",
      Header: "Quantidade Movimentada"
    },
    {
      accessor: "user_operator.name",
      align: "center",
      Header: "Usuário",
      sortable: false
    },
    {
      accessor: "current_stock",
      align: "center",
      Header: "Estoque Atual"
    }
  ]
};

class StockMovementReportView extends Component {
  /*
  downloadButton = () => (
    <Fab
      backgroundColor={colors.secondary.dark}
      tooltip="Download"
      icon="file_download"
      options={[
        {
          backgroundColor: colors.secondary.light,
          onClick: () => this.props.presenter.onDownload('csv'),
          iconComponent: <Icon.CsvFile style={{ fill: colors.secondary.dark }} />,
          tooltip: 'CSV'
        },
        {
          backgroundColor: colors.primary.normal,
          onClick: () => this.handleDownloadButton('pdf'),
          icon: icons.svg.pdfFile,
          tooltip: 'PDF'
        },

      ]}
    />
  );
  */

  render() {
    const { presenter, viewModel } = this.props;
    const {
      loading,
      filters,
      results,
      pagination,
      order,
      userSearchOptions,
      productSearchOptions
    } = viewModel;
    return (
      <Page>
        <Row>
          <Col xs={12} lg={9}>
            <Typography type="display1" className="pb-sm">
              Movimentação de Estoque
            </Typography>
          </Col>
          <Col xs={12} lg={3}>
            <StyledButton
              label="Vendas por Produto"
              leftIcon={<Icons>description</Icons>}
              accent
              onClick={() => presenter.onProductReports()}
            />
          </Col>
        </Row>

        <Row>
          <Col xs={12}>
            <Filter
              loading={loading}
              filters={filters}
              userSearchOptions={userSearchOptions}
              productSearchOptions={productSearchOptions}
              onChange={filter => presenter.onFilterChange(filter)}
              onFilter={filter => presenter.onFilterChange(filter)}
              onSelectUser={user => presenter.onFilterChange({ user })}
              onSelectProduct={product => presenter.onFilterChange({ product })}
            />
          </Col>
        </Row>

        <Row>
          <Col xs={12}>
            <Loadable loading={loading}>
              <Paper elevation={1}>
                <If test={filters.product && filters.product.uuid}>
                  <DataTable
                    manual
                    filterable={false}
                    defaultSorted={[{ id: "created_at", desc: true }]}
                    resultSet={results}
                    total={pagination.total}
                    perPage={pagination.perPage}
                    page={pagination.page}
                    config={config}
                    orderField={order.field}
                    orderDirection={order.direction}
                    onPageChange={page => presenter.onChangePage(page + 1)}
                    onChange={({ field, value }) =>
                      presenter.onChangeOrder({ field, direction: value })
                    }
                  />
                </If>
              </Paper>
            </Loadable>
          </Col>
        </Row>
      </Page>
    );
  }
}

export default StockMovementReportView;



// WEBPACK FOOTER //
// ./src/components/app/management/stock-movement-report/views.jsx